import CaseFollowUps from "./CaseFollowUps";

export default CaseFollowUps;
